import type { SVGProps } from "react";
const SvgArrowRight02Sharp1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19 12H4M15 7l4.293 4.293c.333.333.5.5.5.707s-.167.374-.5.707L15 17"
    />
  </svg>
);
export default SvgArrowRight02Sharp1;
